import React from "react";
import { MyList } from "../../_myBase/components/myList";
import useFieldPreferences from "../../hooks/useFieldPreferences";
import { hostLogFields, hostLogFilters } from "./hostLogFields";

export default function HostLogsList(props) {
  const { visibleFields, loading, updatePreference } = useFieldPreferences(
    "host-logs",
    hostLogFields.map((f) => f.name)
  );

  if (loading) return <div>Loading...</div>;

  const filteredFields = hostLogFields.filter((field) =>
    visibleFields.includes(field.name)
  );

  return (
    <MyList
      resource="host-logs"
      {...props}
      filters={hostLogFilters}
      fields={hostLogFields.map((f) => f.name)}
      onPreferencesUpdate={updatePreference}
    >
      {filteredFields.map(
        ({ name, component: Component, props: fieldProps }) => (
          <Component key={name} source={name} {...fieldProps} />
        )
      )}
    </MyList>
  );
}
